module.exports = __webpack_public_path__ + "img/video.29c1ff10.png";